<template>
    <div class="main">
      <tab title='车队共享设置'></tab>
      <div class="input_box">
        <div class="input_oli">
            <div class="input_title">
                车队账号
            </div>
            <div class="input_main">
                {{ accountNumber }}
            </div>
          </div>
          <div class="input_oli">
            <div class="input_title">
                车队名称
            </div>
            <div class="input_main">
                {{ name }}
            </div>
          </div>
          <div class="input_oli">
            <div class="input_title">
                是否共享车队
            </div>
            <div class="input_main">
                <van-radio-group v-model="checked" direction="horizontal" @change="radioChange">
                    <van-radio name="1">是</van-radio>
                    <van-radio name="0">否</van-radio>
                </van-radio-group>

            </div>
          </div>
          <div class="input_oli" v-if="checked==1">
            <div class="input_title">
                单次锁定加注金额
            </div>
            <div class="input_main">
                <input type="number" v-model="perAmount" placeholder="请输入单次锁定加注金额" maxlength="4">
            </div>
          </div>
      </div>
      <div class="confirm_btn" @click="upd">确认</div>
  
    </div>
  </template>
  
  <script>
  import tab from '@/components/NavBar'
  import Vue from 'vue';
  import { Field,Cell,RadioGroup, Radio} from 'vant';
  import { Toast } from 'vant';
  import { Dialog } from 'vant';
  
  Vue.use(Toast);
  Vue.use(Field);
  Vue.use(Cell);
  Vue.use(RadioGroup);
  Vue.use(Radio);
  
  export default {
    name: 'margin',
    data () {
      return {
        checked:'',
        name:'测试车队客户',
        accountNumber:'13231300168',
        perAmount:''
      }
    },
    components:{
        tab
    },
    mounted(){
        this.getInfo()
    },
    methods:{
        radioChange(e){
            console.log(e)
            if(e==0){
                this.perAmount = ''
            }
        },
        getInfo(){
            this.$api.post('orgapp/getOrgCust',{token:this.$storage.get('token')},res=>{
                console.log(res)
                if(res.data.code==0){
                    var data = res.data.orgCust
                    this.name = data.orgName
                    this.accountNumber = data.mobile
                    this.checked = data.share==null?'0':data.share
                    this.perAmount = data.perAmount==null||data.perAmount==0?'':data.perAmount/100
                    console.log(this.checked)
                }
            })
        },
      upd(){
        if(this.checked == 1 &&this.perAmount==''){
            Toast("请输入单次锁定加注金额！");
            return;
        }
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        var data = {
          token:this.$storage.get('token'),
          share:this.checked,
          perAmount:this.perAmount==''?0:this.perAmount*100
        }
        console.log(data)
        this.$api.post('orgapp/setupShare',data,res=>{
          console.log(res.data)
          if (res.status >= 200 && res.status < 300) {
            var data = res.data
            Toast.clear();
            if(data.msg=="success"){
              Dialog.alert({
                title: '温馨提示',
                message: '修改成功',
              }).then(() => {
                // on close
                this.$router.go(-1);
              });
            }else{
              Dialog.alert({
                title: '温馨提示',
                message: data.msg,
                showCancelButton:false
              }).then(() => {
                
              });
            }
          }else{
            Toast.clear();
            Toast.fail(res.status);
          }
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .main {
      height: 100vh;
      background-color: #F7F8FA;
  }
  .input_box {
      margin-top: 30px;
      background-color: #fff;
  }
  .input_oli {
    width: 90%;
    margin: auto;
    height: 50px;
    line-height: 50px;
    display: flex;
    border-bottom: 2px solid #F3F4F6;
    text-align: left;
  }
  .input_title {
    width: 40%;
  }
  .input_main {
    width: 60%;
    /* display: table-cell;
    vertical-align: middle; */
  }
  .input_main input {
    width: 100%;
    height: 100%;
    border: none;
  }
  .van-radio-group--horizontal {
    vertical-align: middle;
    height: 100%;
    margin:0px;
}
  .confirm_btn {
      width: 70%;
      height: 40px;
      margin: auto;
      margin-top: 20px;
      background-color: #1989FA;
      text-align: center;
      line-height: 40px;
      color: #fff;
      border-radius: 5px;
      /* animation: myAnimation 5s infinite; */
  }
  /* @keyframes myAnimation{
    0%{
      transform: scale(1)
    }
    25%{
      transform: scale(1.2)
    }
    50%{
      transform: scale(1)
    }
    75%{
      transform: scale(1.2)
    }
  } */
  .van-cell__title {
    display: flex!important;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/set_share.vue